import axios from 'axios';

export const sendChatFeedback = (data) => {
  return axios.post('/api/chatbot/message-feedback', data);
};

export const getThreads = () => {
  return axios.get('/api/chatbot/threads');
};

export const getThreadMessages = (threadId) => {
  return axios.get('/api/chatbot/threadMessages', {
    params: { threadId }
  });
};

export const deleteThread = (threadId) => {
  return axios.delete('/api/chatbot/deleteThread', {
    params: { threadId }
  });
};

export const renameThread = (data) => {
  return axios.put('/api/chatbot/renameThread', data);
};
